import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { FormContainerCR } from '@/features/contas-receber/page/forms/FormContainerCR';
import { StringToIdpkSchema } from '@/std/schema';

const RouteContasReceberParamsSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('cadastrar'),
        idpk: z.undefined().optional(),
    }),
    z.object({
        action: z.enum(['editar', 'clonar', 'visualizar']),
        idpk: StringToIdpkSchema,
    }),
]);

export type RouteContasReceberParams = z.infer<typeof RouteContasReceberParamsSchema>;

export const Route = createFileRoute('/a/contas-receber/$action/{-$idpk}')({
    component: Component,
    params: {
        parse: (params) => {
            const result = RouteContasReceberParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const params = Route.useParams();

    return <FormContainerCR {...params} />;
}
